<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="outer">
      <v-data-table
        :headers="headers"
        :items="comm_history"
        item-key="id"
        class="elevation-1 mytable"
        :search="search"       
      >
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>All Notifications</v-toolbar-title>
            <v-divider class="mx-4 mr-10" inset vertical></v-divider>
            <v-text-field
              v-model="search"
              background-color="white"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              style="margin-left: 500px;"
            ></v-text-field>
          </v-toolbar>
        </template>

        <template v-slot:item="{ item, index }">
          <tr :class="item.is_read ? 'white' : 'grey lighten-3'">
            <td>{{ index + 1 }}</td>
            <td>{{ item.sentfrom || "--" }}</td>
            <td>{{ item.senttouser }}</td>
            <td>{{ item.subject }}</td>
            <td>
              <v-icon color="primary" @click="viewMessage(item)">mdi-eye</v-icon>
            </td>
            <td>{{ item.sentto }}</td>
            <td>{{ item.roleType }}</td>
            <td>{{ item.sentdate }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>


    <v-dialog v-model="messageDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline">{{
          selectedMessage.subject
        }}</v-card-title>
        <v-card-text v-html="selectedMessage.body"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="messageDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  

<script>
import axios from "axios";
export default {
  data() {
    return {
      comm_history: [],
      snackbar_msg: "",
      color: "",
      loader: true,
      snackbar: false,
      search: "",
      headers: [
        { text: "Sr. No.", value: "count" },
        { text: "Sent From", value: "sentfrom" },
        //  {text:"Learner", value:"learner"},
        { text: "Recipient", value: "senttouser" },
        { text: "Subject", value: "subject" },
        { text: "Message Body", value: "body" },
        { text: "Sent To", value: "sentto" },
        { text: "Module", value: "roleType" },
        { text: "Send Date", value: "sentdate_sort" },
      ],
      messageDialog: false,
      selectedMessage: {},
    };
  },
  methods: {
    async getAllNotifications() {
      try {
        const res = await axios.post(
          "/communication/getAllCommunicationHistory"
        );
        if (res.data.flag == "YES") {
          this.comm_history = res.data.comm_history;
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
      } catch (err) {
        console.log("err", err);
        this.onerror(err);
      } finally {
        console.log("bye...");
      }
    },
    getParentNotification() {
              // alert("in getCalandar")
              axios
                  .get("communication/getParentNotification")
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.show_calendar = res.data.show_calendar;
                          this.conf_value = res.data.conf_value;
                          this.conf_link = res.data.conf_username;
                          this.comm_history = res.data.comm_history;
                          this.comm_history = res.data.comm_history.map(item => {
                          return {
                            ...item,
                            sentdate_sort: new Date(item.sentdate.split("/").reverse().join("-")) // converts DD/MM/YYYY → YYYY-MM-DD
                          };
                        });
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  });
          },
    showSnackbar(color, msg) {
      this.snackbar = true;
      this.color = color;
      this.snackbar_msg = msg;
    },
    getRowClass(item) {
      return item.is_read ? "white" : "grey lighten-4";
    },
    async viewMessage(item) {
      this.selectedMessage = item;
      this.messageDialog = true;

      const data = {
        notificationId: item.id,
      };
      axios
        .post("/communication/markNotificationAsRead", data)
        .then((res) => {
          if (this.usertype === "Parent") {
            this.getParentNotification();
          } else if (this.usertype === "Employee") {
            this.getAllNotifications();
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); 
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.usertype = localStorage.getItem("EPS-ut");
    if (this.usertype === "Parent") {
      this.getParentNotification();
    } else if (this.usertype === "Employee") {
      this.getAllNotifications();
    }
  },
};
</script>
<style>
.outer {
  background-color: white !important;
  margin: 8px !important;
  padding: 8px;
  border: 2px solid lightgray !important;

}
</style>